import React from 'react'
import { uuid } from 'uuidv4'
import { Col, Row, Tag } from 'antd'

interface VariantNameAndAvatarProps {
  name: string
  testId: string | undefined
  options: string[]
}

const VariantNameAndAvatar = ({
  name,
  testId,
  options
}: VariantNameAndAvatarProps) => {
  return (
    <Row align='middle' gutter={[8, 8]} className='_mb-0'>
      {!!(options || []).length ? (
        options.map((option) => (
          <Tag
            className='-basic'
            key={uuid()}
            data-testid={`${testId}-permutation`}
            style={{
              whiteSpace: 'normal', // allow line breaks
              wordBreak: 'break-word' // break long words if needed
            }}
          >
            {option}
          </Tag>
        ))
      ) : (
        <Col>
          <span data-testid={testId}>{name}</span>
        </Col>
      )}
    </Row>
  )
}

export default VariantNameAndAvatar
